<template>
  <div class="skill__content">
    <p>
      Pagespeed & performance optimization of web assets for images, code, and
      more
    </p>
  </div>
</template>
